export function defineDataVersionService(config) {
    return {
        id: 'data-version-service',
        create: () => ({
            '1.2.0': () => ({ featureService: config })
        })
    };
}
